import { Component, EventEmitter, Inject, LOCALE_ID, Output } from '@angular/core';
import { DropdownOption } from '@cms/shared-library';
import { TranslateService } from '@ngx-translate/core';
import { EnrolmentOption } from '../../../models/class-enrolment.model';

@Component({
    selector: 'app-enrolment-request-options',
    templateUrl: './enrolment-request-options.component.html',
    styleUrls: ['./enrolment-request-options.component.scss'],
    standalone: false
})
export class EnrolmentRequestOptionsComponent {
  enrolRequestOptions: DropdownOption[];
  enrolSingleOptions: DropdownOption[];
  enrolMutipleOptions: DropdownOption[];
  counterLabel: string = '';

  option: EnrolmentOption = { RequestType: '1', RequestFor: '1', Seats: 2 };
  @Output() enrolmentOptionChanged = new EventEmitter<EnrolmentOption>();

  constructor(public translateService: TranslateService) { }

  ngOnInit(): void {
    let lbls = ['ClassEnrolment.SingleEnrolment', 'ClassEnrolment.MultipleEnrolments', 'ClassEnrolment.Myself', 'ClassEnrolment.MyselfAndTeamMembers', 'ClassEnrolment.TeamMember', 'ClassEnrolment.TeamMembers'];
    this.translateService.get(lbls).subscribe((translated: string) => {
      this.enrolRequestOptions = [new DropdownOption(translated[lbls[0]], translated[lbls[0]], 1), new DropdownOption(translated[lbls[1]], translated[lbls[1]], 2)];
      this.enrolSingleOptions = [new DropdownOption(translated[lbls[2]], translated[lbls[2]], 1), new DropdownOption(translated[lbls[3]], translated[lbls[3]], 2)];
      this.enrolMutipleOptions = [new DropdownOption(translated[lbls[4]], translated[lbls[4]], 1), new DropdownOption(translated[lbls[5]], translated[lbls[5]], 2)];
    });
  }

  setEnrolRequestOption(opt: '1' | '2') {
    if (opt == '2') {
      this.option.RequestFor = '1';
    }
    this.option.RequestType = opt;
    this.enrolmentOptionChanged.next(this.option);
  }

  setEnrolOption(opt: '1' | '2') {
    this.option.RequestFor = opt;
    this.enrolmentOptionChanged.next(this.option);
  }
  CreateSeats(seats: number) {
    this.option.Seats = seats;
    this.enrolmentOptionChanged.next(this.option);
  }

  getLabel() {    
    if (this.option.RequestFor == '1') {
       this.translateService.get('ClassEnrolment.SeatsIncludingYourself').subscribe((translated: string) => {
        this.counterLabel = translated
      });
    } else {
      this.translateService.get('ClassEnrolment.SeatsExcludingYourself').subscribe((translated: string) => {
        this.counterLabel = translated
      }); }
    return this.counterLabel
  }

}
